import AbstractEntity from "../AbstractEntity";

export default class Order extends AbstractEntity {

    static STATUS_TO_SUGGEST = 0;
    static STATUS_SUGGESTED = 1;
    static STATUS_IN_PROGRESS = 2;
    static STATUS_COMPLETED = 3;
    static STATUS_CHECKED = 4;

    static END_REASON_QUOTATION_REFUSED = 0;
    static END_REASON_CLIENT_NOT_REPLY = 1;

    static CATEGORY_INTERNAL = 0;
    static CATEGORY_EXTERNAL = 1;
    static CATEGORY_AFFILIATION = 2;

    _id;
    _workId;
    _orderComment;
    _status;
    _endReason;
    _category;
    _createdAt;
    _clientId;
    _interventionsId;
    _addressId;
    _internalCommentsId;

    getId() {
        return this._id;
    }

    getWorkId() {
        return this._workId;
    }

    getOrderComment() {
        return this._orderComment;
    }

    getStatus() {
        return this._status;
    }

    getEndReason() {
        return this._endReason;
    }

    getCategory() {
        return this._category;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getClientId() {
        return this._clientId;
    }

    getInterventionsId() {
        return this._interventionsId;
    }

    getAddressId() {
        return this._addressId;
    }

    getInternalCommentsId() {
        return this._internalCommentsId;
    }

    getClassName() {
        return "order";
    }
}